import { render, staticRenderFns } from "./OpenBillingContactForm.vue?vue&type=template&id=bec3717c&scoped=true&"
import script from "./OpenBillingContactForm.vue?vue&type=script&lang=js&"
export * from "./OpenBillingContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec3717c",
  null
  
)

export default component.exports